export default "__VITE_ASSET__d_u8oWop__"